import { combineReducers } from "redux";
import { reducer as documentsReducer } from "./documentsSlice";
import { reducer as documentCategoriesReducer } from "./documentCategoriesSlice";

export const reducer = combineReducers({
  documents: documentsReducer,
  documentCategories: documentCategoriesReducer,
});
